import {useNavigate, useParams} from "react-router-dom";
import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import {Tab} from "@headlessui/react";
import WorkspaceMemberView from "./WorkspaceMemberView";
import WorkspaceTokenUsageView from "./WorkspaceTokenUsageView";
import useWorkspaceAggregation from "../../../query/workspace/useWorkspaceAggregation";
import {ChevronLeftIcon} from "@heroicons/react/24/outline";
import WorkspaceDeleteAndRestoreTab from "./WorkspaceDeleteAndRestoreTab";
import ChatbotList from "@/view/chatbot/components/ChatbotList";


const WorkspaceDetailTab: React.FC = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const tabList = useMemo(() => [
        {id: 1, title: intl.formatMessage({id: "i11107"}), disabled: false},
        // {id: 2, title: "구독 기록", disabled: false},
        {id: 3, title: intl.formatMessage({id:"i11108"}), disabled: false},
        {id: 4, title: intl.formatMessage({id:"i11109"}), disabled: false},
        {id: 8, title: intl.formatMessage({id:"i11110"}), disabled: false},
    ], [intl])
    const tabClassName = (selected: boolean) => {
        return selected
            ? "transition-colors duration-200 text-gray-500 pb-3 focus:outline-none text-gray-900 border-b border-black font-bold"
            : "transition-colors duration-200 text-gray-500 pb-3 focus:outline-none"
    }
    const {workspaceId} = useParams() as { workspaceId: string };
    const {data: workspaceAggregation} = useWorkspaceAggregation(workspaceId)

    const workspaceName = useMemo(() => {
        return workspaceAggregation?.name ?? `${workspaceAggregation?.user?.fullName}'s Workspace`
    }, [workspaceAggregation])

    const onClickBack = (e: React.MouseEvent) => {
        e.preventDefault();
        navigate(-1);
    };

    return (
        <div className={"flex flex-col h-full p-5"}>
            {workspaceAggregation && (
                <div>
                    <div className="pb-5 border-b-2 flex justify-between mb-5">
                        <div className={"flex items-center text-xl font-semibold space-x-5"}>
                            <button onClick={onClickBack}>
                                <ChevronLeftIcon className="w-6 h-6"/>
                            </button>
                            <div>{workspaceName}</div>
                            {workspaceAggregation.deleted &&
                                <div className="text-red-400 text-sm">
                                    {workspaceAggregation.hardDeleted ? intl.formatMessage({id: "i11112"}) : intl.formatMessage({id: "i11111"})}
                                </div>
                            }
                        </div>
                    </div>

                    <div className={" border-2 border-gray-300 rounded-2xl flex flex-col gap-5"}>
                        <div className={"flex flex-col "}>
                            <Tab.Group defaultIndex={0}>
                                <Tab.List className="px-10 py-[10px] h-auto flex border-b justify-between">
                                    {tabList.map(tab => (
                                        <Tab key={tab.id}
                                             disabled={tab.disabled}
                                             className={({selected}) => tabClassName(selected)}>
                                            {tab.title}
                                        </Tab>
                                    ))}
                                </Tab.List>
                                <Tab.Panels className="flex-grow">
                                    <Tab.Panel>
                                        <ChatbotList clusterId={workspaceAggregation.chatbotClusterId}/>
                                    </Tab.Panel>
                                    {/*<Tab.Panel className="h-full p-5">*/}
                                    {/*    <WorkspaceSubscriptionHistory workspace={workspace}/>*/}
                                    {/*</Tab.Panel>*/}
                                    <Tab.Panel className="h-full p-15">
                                        <WorkspaceTokenUsageView workspace={workspaceAggregation}/>
                                    </Tab.Panel>
                                    <Tab.Panel className="h-full p-5">
                                        <WorkspaceMemberView workspace={workspaceAggregation}/>
                                    </Tab.Panel>
                                    <Tab.Panel className="h-full p-5">
                                        <WorkspaceDeleteAndRestoreTab workspace={workspaceAggregation}/>
                                    </Tab.Panel>
                                </Tab.Panels>
                            </Tab.Group>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WorkspaceDetailTab;
